// In eSTORIS shopping carts and wish lists are stored in the shoppingCartitems table. The only
// difference is the cart type column. Here we've split the two up into ShoppingCart and
// Wish List with the idea that a user can have a single shopping cart and a single wish list.
export * as actions from './actions';
export { default as reducer } from './reducer';
